import { ClickableOptionsCard } from 'core/Components';
import { Stack, Title } from 'ui';
import { useDisclosure } from 'ui/Hooks';

import { PrivacyModal } from '../../../Settings/components/PrivacyModal';
import { DonationSettingsModalGroup } from '../DonationSettingsModalGroup/DonationSettingsModalGroup';
import { CommunicationListsModalGroup } from '../OrgCommunications/CommunicationListsGroup';

const Settings = () => {
  const [isPrivacyModalOpen, privacyModalHandler] = useDisclosure(false);

  return (
    <>
      <Stack>
        <Title order={2}>Settings</Title>
        <ClickableOptionsCard variant="gray">
          <DonationSettingsModalGroup />
          <CommunicationListsModalGroup
            title="Orgs and Communications"
            causeStatusModalTitle="Org Info"
          />
          <ClickableOptionsCard.Row title="Privacy Settings" onClick={privacyModalHandler.open} />
        </ClickableOptionsCard>
      </Stack>
      <PrivacyModal opened={isPrivacyModalOpen} onClose={privacyModalHandler.close} />
    </>
  );
};

export { Settings };
